import { FIXED_WGT_EVENT_PREFIX } from '../..';

const getEventName = (name: string) => `${FIXED_WGT_EVENT_PREFIX}_${name}`;

export default getEventName;
